import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import TableContainer from '../../common/Tablecontainer'; 

const Courses = () => {
  const [showModal, setShowModal] = useState(false);
  const [courses, setCourses] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [formData, setFormData] = useState({
    AmtDesc: '',
    Amount: '',
    AmountDollar: '',
    Duration: ''
  });
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const pageSize = 10;

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await API.get(
      'getAllAmounts/',
      {
      params:{
      page,
      page_size:pageSize,
      search:searchQuery
      }
      }
      );

      if (Array.isArray(response.data)) {

    // जुना API response
          setCourses(response.data);
          setTotalCount(response.data.length);

      } else {

          // नवीन paginated response
          setCourses(response.data.results || []);
          setTotalCount(response.data.count || 0);

      }
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourses([]);
    } finally {
      setLoadingCourses(false);
    }
  };

useEffect(()=>{

fetchCourses();

},[page,searchQuery]);
  const handleCloseModal = () => {
    setFormData({ AmtDesc: '', Amount: '', AmountDollar: '', Duration: '' });
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await API.post('SaveAmountDtls/', formData);
      if (response.data && response.data.includes("OK")) {
        toast.success("Details Saved Successfully!");
        handleCloseModal();
        fetchCourses(); // Refreshes the local dataset after successfully insertion
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to save data. Please check your backend.");
    }
  };

  return (
    <div className="bg-[#f8fafc] min-h-screen font-sans p-3 sm:p-5 md:p-8">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-sans text-gray-800 text-center mb-5 sm:mb-8 tracking-wide">
        Course And Payment Amount Details
      </h2>

      {/* Table Section Framework Node */}
      <div className="max-w-7xl mx-auto bg-white shadow-xl rounded-xl border border-gray-100 p-3 sm:p-5 md:p-6">
        <div className="flex justify-center sm:justify-end mb-4">
          <button 
            onClick={() => setShowModal(true)}
            className="w-full sm:w-auto bg-[#032167] text-white px-5 py-2 rounded-lg font-bold text-sm hover:bg-blue-900 transition-all"
          >
            + ADD NEW COURSE
          </button>
        </div>
        <div className="md:hidden mb-4">
          <input

          type="text"

          placeholder="Search Course..."

          value={searchQuery}

          onChange={(e)=>{
          setSearchQuery(e.target.value);
          setPage(1);
          }}
          className="
          w-full
          border
          rounded-lg
          px-4
          py-3
          outline-none
          focus:ring-2
          focus:ring-blue-500
          "
        />
        </div>
        
        {/* 🟢 FIXED FLOW: Binds data safely using array references, mitigating infinite network loops */}
        <div className="hidden md:block">
        <TableContainer
          columns={['COURSE DESCRIPTION', 'AMOUNT (INR)', 'AMOUNT (DOLLAR)', 'DURATION']}
          apiUrl="getAllAmounts/"
          data={courses}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          loading={loadingCourses}
          searchPlaceholder="Search courses instantly..."
          renderRow={(course, index, srNo, formatCurrency) => (
            <tr key={course.amtId || index} className="border-b border-gray-200 hover:bg-blue-50/40 text-[13px] text-center transition-colors">
              <td className="py-3 px-2 border-r bg-gray-50/30 text-center">{srNo}</td>
              <td className="py-4 px-6 border-r font-bold text-gray-700 text-left uppercase">{course.AmtDesc}</td>
              <td className="py-4 px-6 border-r text-right pr-6 font-mono font-bold text-emerald-600">₹{formatCurrency(course.Amount)}</td>
              <td className="py-4 px-6 border-r text-right pr-6 font-mono font-bold text-indigo-700">${formatCurrency(course.AmountDollar)}</td>
              <td className="py-4 px-6 border-r text-center font-semibold text-gray-600">{course.Duration} Days</td>
            </tr>
          )}
        />

        </div>
      </div>
      <div className="md:hidden space-y-4">

        {courses.map((course) => (

          <div
            key={course.amtId}
            className="bg-white border rounded-xl shadow-sm p-4"
          >

            <div className="flex justify-between mb-2">

              <h3 className="font-bold text-[#032167] text-base">
                {course.AmtDesc}
              </h3>

              <span
                  className="
                      ml-auto
                      block
                      text-right
                      text-xs
                      px-1
                      py-1
                  "
              >
                  {course.Duration} Days
              </span>

            </div>

            <div className="space-y-2">

              <div className="flex justify-between">
                <span className="text-gray-500">Amount</span>

                <span className="font-bold text-green-700">
                  ₹{course.Amount}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Dollar</span>

                <span className="font-bold text-indigo-700">
                  ${course.AmountDollar}
                </span>
              </div>

            </div>

          </div>

        ))}

      </div>
      <div className="md:hidden flex justify-between items-center mt-5">

        <button

        disabled={page===1}

        onClick={()=>setPage(page-1)}

        className="px-4 py-2 rounded bg-gray-200 disabled:opacity-50">

        Previous

        </button>

        <span>

        Page {page} of {Math.ceil(totalCount/pageSize)}

        </span>

        <button

        disabled={
        page>=Math.ceil(totalCount/pageSize)
        }

        onClick={()=>setPage(page+1)}

        className="px-4 py-2 rounded bg-[#032167] text-white disabled:opacity-50">

        Next

        </button>

      </div>
      {courses.length===0 && (

      <div className="text-center py-10">

      No Course Found

      </div>

      )}

      

      {/* Add New Course Modal Sheet */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999] animate-fadeIn">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg sm:max-w-xl md:max-w-3xl lg:max-w-4xl mx-3 relative border border-gray-100 overflow-hidden animate-in zoom-in-95 duration-200">
            <div className="bg-[#032167] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-bold tracking-wide uppercase m-0">Add Course Details</h3>
              <button onClick={handleCloseModal} className="text-white/80 hover:text-white text-2xl font-bold bg-transparent border-none cursor-pointer">&times;</button>
            </div>
            <div className="p-6">
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-bold text-gray-700 uppercase">Course Description *</label>
                  <input type="text" value={formData.AmtDesc} className="w-full border border-gray-300 p-2.5 rounded-lg text-sm bg-gray-50/50 outline-none" onChange={(e) => setFormData({...formData, AmtDesc: e.target.value})} required />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-bold text-gray-700 uppercase">Amount (in Rs) *</label>
                    <input type="number" value={formData.Amount} className="w-full border border-gray-300 p-2.5 rounded-lg text-sm bg-gray-50/50 outline-none" onChange={(e) => setFormData({...formData, Amount: e.target.value})} required />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-bold text-gray-700 uppercase">Amount (in Dollar) *</label>
                    <input type="number" value={formData.AmountDollar} className="w-full border border-gray-300 p-2.5 rounded-lg text-sm bg-gray-50/50 outline-none" onChange={(e) => setFormData({...formData, AmountDollar: e.target.value})} required />
                  </div>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-bold text-gray-700 uppercase">Duration (in days) *</label>
                  <input type="number" value={formData.Duration} className="w-full border border-gray-300 p-2.5 rounded-lg text-sm bg-gray-50/50 outline-none" onChange={(e) => setFormData({...formData, Duration: e.target.value})} required />
                </div>
                <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t">
                  <button type="button" onClick={handleCloseModal} className="w-full sm:w-auto px-5 py-2 rounded-lg border border-gray-300 text-sm font-semibold hover:bg-gray-50 cursor-pointer bg-white">Cancel</button>
                  <button type="submit" className="bg-[#032167] text-white w-full sm:w-auto px-8 py-2 rounded-lg font-bold text-sm cursor-pointer border-none shadow-sm hover:bg-blue-900 transition-colors">SAVE DETAILS</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Courses;



